module.exports = __webpack_public_path__ + "static/img/twjd-sdh3.ffb406d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdh3.png
// module id = 848
// module chunks = 0